module.exports = __webpack_public_path__ + "img/CRT_Sword-006.129461ad.png";